import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { installSessionRefresh, installIdleLogout, markActive } from "@/lib/session";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Registered before the /auth/me call below, so an expired access token on page load is refreshed too.
  useEffect(() => installSessionRefresh(axios, () => setUser(false)), []);

  useEffect(() => {
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then(r => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const signedIn = !!user;
  useEffect(() => {
    if (!signedIn) return undefined;
    return installIdleLogout(() => {
      axios.post(`${API}/auth/logout`, {}, { params: { everywhere: false }, withCredentials: true })
        .catch(() => {})
        .finally(() => setUser(false));
    });
  }, [signedIn]);

  const login = async (email, password) => {
    await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    markActive();
    const { data } = await axios.get(`${API}/auth/me`, { withCredentials: true });
    setUser(data);
    return data;
  };

  const logout = async () => {
    await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
